import { PageHeader } from "./ServiceDetail";
import { GoldButton, Reveal } from "../components/ui-kit";
import { useContent } from "../context/ContentContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Faq() {
  const { content } = useContent();
  const faq = content?.faq || [];
  return (
    <div data-testid="faq-page">
      <PageHeader overline="Questions fréquentes" title="Vous vous posez des questions ?" subtitle="Retrouvez les réponses aux questions les plus courantes. Une autre demande ? Contactez-nous directement." />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
              {faq.map((item, i) => (
                <AccordionItem key={item.q} value={`item-${i}`} className="glass rounded-xl px-6 border-white/10">
                  <AccordionTrigger className="text-left font-serif text-lg hover:no-underline hover:text-gold py-5" data-testid={`faq-q-${i}`}>{item.q}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pb-5">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
          <div className="text-center mt-12"><GoldButton to="/devis" data-testid="faq-devis-btn">Demander un devis</GoldButton></div>
        </div>
      </section>
    </div>
  );
}
